import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import * as yup from "yup";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import SmartButton from "../../components/SmartButton";
import SmartInput from "../../components/SmartInput";
import "./styles.scss";
import { URL_PATHS } from "../../routes";

interface LoginPageProps {
    onLoginEmail: (email: string) => Promise<void>;
    isLoading: boolean;
}

const schema = yup.object().shape({
    email: yup
        .string()
        .email("入力されたメールアドレスは無効です")
        .required("メールアドレスを入力してください")
});

const LoginPage = (props: LoginPageProps) => {
    const {
        register,
        handleSubmit,
        errors,
        formState: { isDirty, isValid }
    } = useForm({
        mode: "all",
        resolver: yupResolver(schema)
    });
    const onSubmit = (data) => props.onLoginEmail(data.email);

    return (
        <MainLayout isBurgerHidden={true}>
            <Headline>パートナーエージェントAppにログイン</Headline>
            <div className="input-email-label">
                登録済のメールアドレスを入力してください。
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="form">
                <div className="input-wrapper">
                    <SmartInput
                        name="email"
                        register={register}
                        error={errors.email}
                        placeholder="sample@p-a.app"
                        showPrivateMark={true}
                    />
                </div>

                <div className="spacer"></div>
                <SmartButton
                    type="submit"
                    disabled={!isDirty || !isValid}
                    isLoading={props.isLoading}
                >
                    認証コードを送信する
                </SmartButton>
                <div className="not-submitted">
                    未登録の方は
                    <Link to={URL_PATHS.installApp}>
                        こちらからダウンロード
                    </Link>
                </div>
            </form>
        </MainLayout>
    );
};

export default LoginPage;
